<div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header" *ngIf="redirect?.state?.isDialog">
    <div class="flex items-center">
      <h6 mat-dialog-title class="font-semibold primary-font">{{'create.new_job.text' | translate}}</h6>
    </div>
    <div class="flex items-center mr-1">
      <span (click)="closeModal()" class="rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </span>
    </div>
</div>
<div class="parent-container flex w-full" [ngClass]="{'dialog-parent-container': redirect?.state?.isDialog}">
    <div class="left-pane w-full px-3 zuper-scrollbar pb-3" #scrollElementLeft>
        <ng-container *ngFor="let formName of formPlacement['left']">
            <div *ngTemplateOutlet="formName">
            </div>
        </ng-container>
       
    </div>
    <div class="center-pane w-full px-3 zuper-scrollbar pb-3" #scrollElementCenter>
        <ng-container *ngFor="let formName of formPlacement['center']">
            <div *ngTemplateOutlet="formName">
            </div>
        </ng-container>
    </div>
    <div class="right-pane w-full pb-3 zuper-scrollbar bg-white" #scrollElementRight>
        <ng-container *ngFor="let formName of formPlacement['right']">
            <div *ngTemplateOutlet="formName">
            </div>
        </ng-container>
    </div>
</div>
<div mat-dialog-actions class="flex justify-end space-x-3 border-t border-gray-300 zuper-dialog-footer" *ngIf="redirect?.state?.isDialog">
    <button mat-stroked-button (click)="closeModal()" class="px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white btn-small hover:bg-gray-50 focus:outline-none" type="button">{{'cancel.text' | translate}}</button>
    <button (click)="getFormValue()" class="bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white font-medium rounded-md text-white-600 btn-small focus:outline-none" type="submit">{{"create.job.text" | translate}}</button>
</div>


<!-- Job Details -->
<ng-template #jobDetailsRef>
    <a class="block w-full bg-white border border-gray-200 rounded-lg mt-3">
        <mat-expansion-panel  [expanded]="true" class="rounded-lg">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="w-full flex" [ngClass]="{'justify-between': showInvalidIcon('jobDetails')}">
                    <h5 class="my-3 flex items-center text-lg font-semibold text-gray-700 my-3">
                        <i class="ti ti-briefcase text-2xl"></i>
                        <span class="ml-3">{{"ppm.details.expansion.header_job_details" | translate}}</span>
                    </h5>
                    <i class="ti ti-exclamation-circle text-2xl my-3 text-red-500" *ngIf="showInvalidIcon('jobDetails')"></i>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <form class="grid grid-cols-6 gap-3 mt-3 mx-4 mb-6" [formGroup]="jobForm.get('jobDetails')">
                <!-- Prefix -->
                <div class="col-span-3 xl:col-span-2">
                    <label for="prefix" class="block text-base font-medium text-gray-700">{{"forms.label.prefix" | translate}}</label>
                    <input 
                    type="text" 
                    name="prefix" 
                    formControlName="prefix"
                    id="prefix" 
                    class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base"
                    placeholder="{{ 'forms.label.prefix.placeholder' | translate}}"
                    >        
                </div>

                <!-- Job Title -->
                <div class="col-span-3 xl:col-span-2">
                    <label for="title" class="block text-base font-medium text-gray-700">{{"text.job_title" | translate}}
                        <span class="mandatory-field">*</span> 
                    </label>
                    <input 
                    type="text" 
                    name="title" 
                    formControlName="jobTitle"
                    id="title" 
                    class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base"
                    placeholder="{{ 'input.placeholder.enter_job_title' | translate}}"
                    >   
                    <p class="text-red-500 text-base" *ngIf="utilityService.getErrorMessage(jobForm.get('jobDetails'), 'jobTitle')">{{utilityService.getErrorMessage(jobForm.get('jobDetails'), 'jobTitle') | translate}}</p>    
                </div>
            </form>
        </mat-expansion-panel>
    </a>
</ng-template>

<!-- Job Schedule -->
<ng-template #jobScheduleRef>
    <a class="block w-full bg-white border border-gray-200 rounded-lg mt-3">
        <mat-expansion-panel  [expanded]="true" class="rounded-lg">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h5 class="my-4 flex items-center w-full justify-between text-lg font-semibold text-gray-700">
                    <div class="flex items-center">
                        <i class="ti ti-calendar-stats text-2xl"></i>
                        <span class="ml-3">
                            {{"header.title.job_schedule" | translate}} 
                        </span>
                    </div>
                    <div class="flex justify-between items-center space-x-2">
                        <i class="ti ti-exclamation-circle text-2xl my-3 text-red-500" *ngIf="showInvalidIcon('jobSchedule')"></i>
                        <p class="text-base text-primary leading-tight"  (click)="openAssistedScheduler($event)">{{'jobs.check_availability' | translate}}</p>
                    </div>
                </h5>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="rounded-md bg-blue-50 px-4 py-3" *ngIf="!hasDates()">
                <div class="flex">
                    <div class="flex-shrink-0">
                    <i class="ti ti-alert-circle text-blue-700 text-2xl"></i>
                    </div>
                    <div class="ml-3 flex-1 md:flex md:justify-between">
                    <p class="text-base text-blue-700">{{"alert.due_date_schedule_date_mandatory" | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="rounded-md bg-orange-50 px-4 py-3" *ngIf="conflictingJobs">
                <div class="flex">
                    <div class="flex-shrink-0">
                        <i class="ti ti-alert-circle text-orange-700 text-2xl"></i>
                    </div>
                    <div class="ml-3">
                        <p class="text-base font-semibold text-orange-700 flex justify-between">
                            {{"alert.conflicting_job_schedule" | translate}}
                            <span class="ml-auto underline cursor-pointer text-base" (click)="viewJobs()">{{'view.jobs' | translate}}</span>
                        </p>
                        <p class="text-base text-orange-700">{{conflictingJobs}} 
                            <span *ngIf="selectedCustomers?.length">{{"alert.conflicting_job.description" | translate}}</span>
                            <span *ngIf="!selectedCustomers?.length && selectedOrganizations?.length">{{'alert.conflicting_job_organization.description' | translate}}</span>
                        </p>
                    </div>
                </div>
            </div>
            <form class="grid grid-cols-6 gap-3 mx-4 my-3 mb-6" [formGroup]="jobForm.get('jobSchedule')">

                <!-- Timezone -->
                 <ng-container *ngIf="utilityService.isTimeZoneEnabled">
                    <div class="col-span-3 xl:col-span-2">
                        <div class="block">
                            <div class="time-zone-drop-down flex items-center justify-between pr-2" >
                                <i class="ti ti-world text-2xl mr-2 mt-1 text-gray-600"></i>
                                <ng-select class="w-full mt-1 border-l-0" [formControlName]="'job_timezone'" [clearable]="false" [items]="timeZoneData"
                                    bindValue="key" bindLabel="display_name" [searchFn]="timezoneService.customTimezoneSearch" [multiple]="false"
                                    [hideSelected]="true" [placeholder]="'text.choose_timezone' | translate">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <hr>
                 </ng-container>


                <!-- Due Date -->
                <div class="col-span-3 xl:col-span-2" *ngIf="!jobForm.controls['jobSchedule'].get('recurrence').value">
                    <div class="flex items-center justify-between">
                        <label for="dueDate" class="block text-base font-medium text-gray-700 w-full">{{"due.date.text" | translate}}</label>
                        @if (jobForm.controls['jobSchedule']?.get('dueDate')?.value) {
                        <div class="w-full text-right text-primary overflow-hidden">
                            <span class="hover:underline cursor-pointer truncate"
                                (click)="clearDueDate()">{{'overall_search.recently_viewed.clear' | translate}}</span>
                        </div>
                        }
                    </div>
                    <input 
                        [matDatepicker]="dueDatepicker" readonly
                        type="text" 
                        name="dueDate"
                        [min]="today" 
                        id="dueDate"  
                        formControlName="dueDate"
                        class="mt-1  block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base cursor-pointer"
                        [placeholder]="utilityService.getLocaleValue('input.placeholder.pick_date')"
                        (click)="dueDatepicker.open(); togglePicker($event)"
                        (dateChange)="handleBlur()"
                        value=""
                        [datePickerFormat]="dateFormat"
                    >     
                    <mat-datepicker  #dueDatepicker></mat-datepicker>
                    <p class="text-red-500 text-base" *ngIf="jobForm.get('jobSchedule')?.controls?.dueDate?.touched && jobForm.get('jobSchedule')?.controls?.dueDate?.invalid">{{'text.due.date.min.error.message' | translate}}</p>
                </div>

                <!-- Job Start Date & Time -->
                <div class="col-span-3 xl:col-span-2">
                    <div class="flex items-center justify-between">
                        <label for="jobFormStartDate" class="block text-base font-medium text-gray-700 w-full">{{"input.label.job_start_date_time" | translate}}</label>
                        @if (!jobForm.controls['jobSchedule'].get('recurrence').value && (jobForm.controls['jobSchedule']?.get('startDate')?.value || jobForm.controls['jobSchedule']?.get('endDate')?.value)) {
                            <div class="w-full text-right text-primary overflow-hidden">
                                <span class="hover:underline cursor-pointer truncate" (click)="clearScheduledDate()">{{'overall_search.recently_viewed.clear' | translate}}</span>
                            </div>
                        }
                    </div>
                    <input 
                        id="jobFormStartDate" readonly
                        name="startDateName" 
                        class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base cursor-pointer"
                        [ngxMatDatetimePicker]="startDateTimePicker" 
                        (click)="setDate(jobForm.get('jobSchedule'), startDateTimePicker, 'startDate'); startDateTimePicker?.open();togglePicker($event)" ngDefaultControl
                        (ngModelChange)="startDateChange(); handleBlur()"
                        [(ngModel)]="startDate"
                        formControlName="startDate"
                        placeholder="{{'generatefilter.datetimefield.placeholder' | translate}}"
                        [datePickerFormat]="dateTimeFormat"
                    >
                    <ngx-mat-datetime-picker #startDateTimePicker [showSpinners]="true"
                        [showSeconds]="false" [stepHour]="1" [stepMinute]="15" [stepSecond]="1"
                        [touchUi]="false" [enableMeridian]="showMeridian" [disableMinute]="false">
                        <ngx-mat-datepicker-actions>
                            <button mat-flat-button color="primary" ngxMatDatepickerApply>{{'text.ok' | translate}}</button>
                        </ngx-mat-datepicker-actions>
                    </ngx-mat-datetime-picker>
                </div>

                <!-- Job End Date & Time -->
                <div class="col-span-3 xl:col-span-2">
                    <label for="jobFormEndDate" class="block text-base font-medium text-gray-700">{{"input.label.job_end_date_time" | translate}}</label>
                    <input 
                        id="jobFormEndDate" readonly
                        name="endDateName" 
                        class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base cursor-pointer"
                        [ngxMatDatetimePicker]="endDateTimePicker" 
                        (click)="setDate(jobForm.get('jobSchedule'), endDateTimePicker, 'endDate'); endDateTimePicker?.open();togglePicker($event)" ngDefaultControl
                        formControlName="endDate"
                        (ngModelChange)="endDateChange(); handleBlur()"
                        placeholder="{{'generatefilter.datetimefield.placeholder' | translate}}"
                        [datePickerFormat]="dateTimeFormat"
                        >
                    <ngx-mat-datetime-picker #endDateTimePicker [showSpinners]="true"
                        [showSeconds]="false" [stepHour]="1" [stepMinute]="15" [stepSecond]="1"
                        [touchUi]="false" [enableMeridian]="showMeridian" [disableMinute]="false">
                        <ngx-mat-datepicker-actions>
                            <button mat-flat-button color="primary" ngxMatDatepickerApply>{{'text.ok' | translate}}</button>
                        </ngx-mat-datepicker-actions>
                    </ngx-mat-datetime-picker>
                </div>

                <!-- Job Recurrence -->
                <div class="col-span-3 xl:col-span-2" *ngIf="companyConfig?.jobs?.allow_recurring_job">
                    <label for="recurrence" class="block text-base font-medium text-gray-700 cursor-pointer">
                        {{"input.label.job_recurrence" | translate}}
                        <span class="text-primary" *ngIf="showUpdateRecurrence()" (click)="openUpdateRecurrence()">({{"button.update_recurrence" | translate}})</span>
                    </label>
                    <mat-form-field appearance="fill" class="w-full mt-1 ">
                        <mat-select disabled="{{(this.redirect?.state?.isRecurringJob === false) && this.redirect?.state?.project}}" formControlName="recurrence" (selectionChange)="recurrenceChange()">
                          <mat-option value="" > {{"input.value.no_recurrence" | translate}}</mat-option>
                          <mat-option [value]="true"> {{"input.value.recurring_job" | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <p class="text-primary text-base capitalize" *ngIf="getParsedRRuleValue(currentRruleValue?.rrule)">{{getParsedRRuleValue(currentRruleValue?.rrule)}}</p>
                    <p class="text-base font-semibold text-orange-700 flex justify-between" *ngIf="showContractAlertDisplay">
                        {{"input.label.job_recurrence_end_date_restrict" | translate}}
                    </p>
                    <p class="text-base capitalize mt-1" *ngIf="currentRruleCount">{{"text.total_jobs" | translate}}: {{currentRruleCount}}</p>
                </div>
                <ng-container *ngIf="jobForm.get('jobSchedule').get('startDate').value && jobForm.get('jobSchedule').get('endDate').value && utilityService.isTimeZoneEnabled" >
                 <div class="rounded-md text-black bg-gray-100 p-2 flex items-center" >
                    <span class="text-base text-gray-700">
                        <b>{{fromTimeInAccountTimeZone }}->{{toTimeInAccountTimeZone }}
                        </b> {{'text.account.timezone' | translate}}
                    </span>
                </div>
                </ng-container>
            </form>
        </mat-expansion-panel>
    </a>
</ng-template>

<ng-template #serviceAddressRef>
    <a class="block mt-4 w-full bg-white border border-gray-200 rounded-lg">
        <h5 class="my-4 mx-4 flex items-center justify-between text-lg font-semibold text-gray-700">
            <div class="flex items-center">
                <i class="ti ti-map-2 text-2xl"></i>
                <span class="ml-3">
                    {{"text.service_address" | translate}} <span class="mandatory-field">*</span> 
                </span>
            </div>
            <div>
                <i class="ti ti-exclamation-circle text-2xl mx-2 text-red-500" *ngIf="showInvalidIcon('serviceAddress')"></i>
                <i class="ti ti-pencil text-2xl p-1 rounded-full hover:bg-gray-200" title="{{'tooltip.edit.service_address' | translate}}" *ngIf="currentServiceAddress?.street" (click)="openServiceAddress()"></i>
                <i class="ti ti-trash text-2xl p-1 rounded-full hover:bg-red-200 text-red-500" title="{{'tooltip.remove.service.address' | translate}}" *ngIf="currentServiceAddress?.street" (click)="clearServiceAddress()"></i>
                <i class="ti ti-settings text-2xl p-1 rounded-full hover:bg-gray-200" title="{{'tooltip.add.choose_another_address' | translate}}" (click)="openAllAddressesModal('SERVICE')" *ngIf="this.addressOptions['addressList']?.length"></i>
            </div>
        </h5>
        <hr class="mt-3 mb-0 w-full border-b-0">
        <div class="flex justify-start items-center rounded-md space-x-2 bg-gray-50 px-4 py-3" *ngIf="service_territory?.matched_territory && isServiceTerritoryEnabled">
            <em class="ti ti-compass text-3xl icon-primary flex justify-start items-center" matTooltip="{{'dispatch.filter.service_territory.label' | translate}}"></em>
            <span class="text-base primary-font text-gray-700 max-w-96 break-words whitespace-wrap flex justify-start items-center" *ngIf="service_territory?.matched_territory?.territory?.territory_name">{{service_territory?.matched_territory?.territory?.territory_name}}</span>
            <span class="text-base primary-font text-gray-700 max-w-96 break-words whitespace-wrap flex justify-start items-center" *ngIf="!service_territory?.matched_territory?.territory?.territory_name">{{'text.no.territory.found' | translate}}</span>
            <div class="flex justify-start items-center" *ngIf="service_territory?.matched_territory?.is_conflict === true && service_territory?.matched_territory?.territory?.territory_name"
                [ngxTippy]="territoryNewConflict"
                [tippyName]="'territoryNewConflict'"
                [tippyProps]="{
                    allowHTML: true,
                    theme: 'light',
                    trigger:'click',
                    interactive: true,
                    zIndex:999,
                    appendTo: 'parent',
                    placement: 'bottom'
                  }">
                <em class="ti ti-alert-triangle text-2xl icon-primary mt-1"></em>
              </div>
        </div>
        <div [ngClass]="{'px-4 mb-3': !showServiceAddress, 'p-3': showServiceAddress}" *ngIf="currentServiceAddress?.street">
            <location-preview [options]="serviceMapOption" *ngIf="showServiceAddress"></location-preview>
            <div class="mt-3" >
                <p class="text-base font-semibold">{{currentServiceAddress?.firstName}} {{currentServiceAddress?.lastName}}</p>
                <p class="text-base">
                    <span *ngIf="currentServiceAddress?.street">{{currentServiceAddress?.street}}</span>
                    <span *ngIf="currentServiceAddress?.landmark">, {{currentServiceAddress?.landmark}}</span>
                    <span *ngIf="currentServiceAddress?.city">, {{currentServiceAddress?.city}}</span>
                    <span *ngIf="currentServiceAddress?.state">, {{currentServiceAddress?.state}}</span>
                    <span *ngIf="currentServiceAddress?.zipcode">, {{currentServiceAddress?.zipcode}}</span>
                </p>
            </div>
        </div>
        <div class="flex flex-col items-center" *ngIf="!currentServiceAddress?.street">
            <div class="p-6">
                <img src="assets/images/svgs/service_address_placeholder.svg" class="w-48" alt="">
            </div>
            <div class="mb-6">
                <a mat-stroked-button 
                (click)="openServiceAddress()"
                class="inline-flex items-center px-4 py-3 h-9 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">{{"button.label.add_service_address" | translate}}</a>
            </div>
        </div>
    </a>
</ng-template>


<ng-template #billingAddressRef>
    <a class="block mt-4 w-full bg-white border border-gray-200 rounded-lg">
        <h5 class="my-4 mx-4 flex items-center justify-between text-lg font-semibold text-gray-700">
            <div class="flex items-center">
                <i class="ti ti-map-2 text-2xl"></i>
                <span class="ml-3">
                    {{"billing.address.text" | translate}} <span class="mandatory-field">*</span> 
                </span>
            </div>
            <div>
                <i class="ti ti-exclamation-circle text-2xl mx-2 text-red-500" *ngIf="showInvalidIcon('billingAddress')"></i>
                <i class="ti ti-pencil text-2xl p-1 rounded-full hover:bg-gray-200" title="{{'tooltip.edit.billing_address' | translate}}" *ngIf="currentBillingAddress?.street && !sameAsServiceAddress" (click)="openBillingAddress()"></i>
                <i class="ti ti-trash text-2xl p-1 rounded-full hover:bg-red-200 text-red-500" title="{{'tooltip.remove.billing_address' | translate}}" *ngIf="currentBillingAddress?.street && !sameAsServiceAddress" (click)="clearBillingAddress()"></i>
                <i class="ti ti-settings text-2xl p-1 rounded-full hover:bg-gray-200" title="{{'tooltip.add.choose_another_address' | translate}}" *ngIf="this.addressOptions['addressList']?.length && !sameAsServiceAddress" (click)="openAllAddressesModal('BILLING')"></i>
            </div>
        </h5>
        <hr class="mt-3 mb-0 w-full border-b-0">
        <div class="flex justify-start items-center font-semibold text-base p-4">
            <input id="sameAsServiceAddress" [(ngModel)]="sameAsServiceAddress" type="checkbox" (change)="onBillingAddressFlagChange()" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded">
            <label for="sameAsServiceAddress" class="block text-base text-gray-700 ml-3 cursor-pointer leading-tight">{{"text.same_as_service_address" | translate}}</label>
        </div>
        <hr class="mb-0 w-full border-b-0" *ngIf="!sameAsServiceAddress">
        <ng-container *ngIf="!sameAsServiceAddress">
            <div class="px-4 mb-3" *ngIf="currentBillingAddress?.street">
                <div class="mt-3" >
                    <p class="text-base font-semibold">{{currentBillingAddress?.firstName}} {{currentBillingAddress?.lastName}}</p>
                    <p class="text-base">
                        <span *ngIf="currentBillingAddress?.street">{{currentBillingAddress?.street}}</span>
                        <span *ngIf="currentBillingAddress?.landmark">, {{currentBillingAddress?.landmark}}</span>
                        <span *ngIf="currentBillingAddress?.city">, {{currentBillingAddress?.city}}</span>
                        <span *ngIf="currentBillingAddress?.state">, {{currentBillingAddress?.state}}</span>
                        <span *ngIf="currentBillingAddress?.zipcode">, {{currentBillingAddress?.zipcode}}</span>
                    </p>
                </div>
            </div>
            <div class="flex flex-col items-center" *ngIf="!currentBillingAddress?.street">
                <div class="p-6">
                    <img src="assets/images/svgs/service_address_placeholder.svg" class="w-48" alt="">
                </div>
                <div class="mb-6">
                    <a mat-stroked-button 
                    (click)="openBillingAddress()"
                    class="inline-flex items-center px-4 py-3 h-9 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">{{"button.label.add_billing_address" | translate}}</a>
                </div>
            </div>
        </ng-container>
    </a>
</ng-template>

<!-- Primary Details -->
<ng-template #primaryDetailsRef>
    <a class="block w-full bg-white border border-gray-200 rounded-lg mt-3">
        <mat-expansion-panel  [expanded]="true" class="rounded-lg">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="w-full flex" [ngClass]="{'justify-between': showInvalidIcon('primaryDetails')}">
                    <h5 class="my-3 flex items-center text-lg font-semibold text-gray-700 my-3">
                        <i class="ti ti-layout-list text-2xl"></i> 
                        <span class="ml-3">{{"text.primary_details" | translate}}</span>
                    </h5>
                    <i class="ti ti-exclamation-circle text-2xl my-3 text-red-500" *ngIf="showInvalidIcon('primaryDetails')"></i>
                </div>
                
              </mat-panel-title>
            </mat-expansion-panel-header>
            <form class="grid grid-cols-6 gap-3 mx-4 my-3 mb-6" [formGroup]="jobForm.get('primaryDetails')">
                <!-- Job Category -->
                <div class="col-span-3 xl:col-span-2">
                    <label for="category" class="block text-base font-medium text-gray-700 cursor-pointer">
                        <span>
                            {{"job.category" | translate}}
                            <span class="mandatory-field">*</span> 
                        </span>
                        <span class="text-primary" *ngIf="userRole === 'ADMIN'" (click)="openNewCategory()"> ({{"link.label.new_category" | translate}})</span>
                    </label>
                    <mat-form-field appearance="fill" class="w-full mt-1 ">
                        <mat-select  formControlName="category" (selectionChange)="jobCategoryChange()">
                            <mat-option value="" [disabled]="true"> {{"text.choose_job_category" | translate}}</mat-option>
                            <mat-option *ngFor="let category of jobCategory" [value]="category.category_uid" > {{category.category_name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <p class="text-red-500 text-base" *ngIf="utilityService.getErrorMessage(jobForm.get('primaryDetails'), 'category')">{{utilityService.getErrorMessage(jobForm.get('primaryDetails'), 'category') | translate}}</p>
                    <p class="mt-0.5  text-primary text-base" *ngIf="currentCategory?.estimated_duration">{{"label.estimated_duration" | translate}}: 
                        <span *ngIf="currentCategory?.estimated_duration?.days">{{currentCategory?.estimated_duration?.days}} {{"text.days" | translate}}</span>
                        <span *ngIf="currentCategory?.estimated_duration?.hours"> {{currentCategory?.estimated_duration?.hours}} {{"label.hours" | translate}}</span>
                        <span *ngIf="currentCategory?.estimated_duration?.minutes"> {{currentCategory?.estimated_duration?.minutes}} {{"label.minutes" | translate}}</span>
                    </p>
                </div>

                <!-- Job Priority -->
                <div class="col-span-3 xl:col-span-2">
                    <label for="priority" class="block text-base font-medium text-gray-700 cursor-pointer">
                        {{"text.job_priority" | translate}}
                    </label>
                    <mat-form-field appearance="fill" class="w-full mt-1 ">
                        <mat-select  formControlName="priority">
                            <mat-option value="" [disabled]="true"> {{"option.value.choose_job_priority" | translate}}</mat-option>
                            <mat-option value="LOW"> {{"text.low" | translate}}</mat-option>
                            <mat-option value="MEDIUM"> {{"text.medium" | translate}}</mat-option>
                            <mat-option value="HIGH"> {{"text.high" | translate}}</mat-option>
                            <mat-option value="URGENT"> {{"text.urgent" | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>   

                <!-- Job Type -->
                <div class="col-span-3 xl:col-span-2">
                    <label for="jobType" class="block text-base font-medium text-gray-700 cursor-pointer">
                        {{"text.job_type" | translate}}
                    </label>
                    <mat-form-field appearance="fill" class="w-full mt-1 ">
                        <mat-select  formControlName="jobType" (selectionChange)="jobTypeChange(true)">
                            <mat-option value="" [disabled]="true"> {{"job.type.placeholder" | translate}}</mat-option>
                            <mat-option value="NEW"> {{"text.new_job" | translate}}</mat-option>
                            <mat-option value="REVISIT"> {{"job.type.revisit" | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>    
                
                <!-- Parent Job -->
                <div class="col-span-3 xl:col-span-2">
                    <label for="parent" class="block text-base font-medium text-gray-700">
                        {{"job.detail.parent.job.label" | translate}}
                        <span class="mandatory-field" *ngIf="showParentMandatory">*</span> 
                    </label>
                    <div class="relative">
                        <input 
                            type="text" 
                            name="parent" 
                            formControlName="parent"
                            id="parent" 
                            class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm pl-3 py-3 leading-none pr-10 text-base"
                            placeholder="{{ 'job.form.click_to_choose_parent_job' | translate}}"
                            (click)="toggleParentJob()"
                            autocomplete="off"
                            [ngClass]="{'bg-gray-100 cursor-not-allowed pointer-events-none': selectedCustomers?.length === 0 && selectedOrganizations?.length === 0, 'cursor-pointer': (selectedCustomers?.length > 0 || selectedOrganizations?.length > 0)}"
                            [disabled]="selectedCustomers?.length === 0 && selectedOrganizations?.length === 0"
                        >  
                        <div class="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer" *ngIf="selectedJob.length > 0" (click)="removeParentJob()">
                            <i class="ti ti-x text-xl font-medium"></i>
                        </div>
                    </div>       
                    <p class="text-red-500 text-base" *ngIf="utilityService.getErrorMessage(jobForm.get('primaryDetails'), 'parent')">{{utilityService.getErrorMessage(jobForm.get('primaryDetails'), 'parent') | translate}}</p> 
                </div>

                <div class="col-span-6 lg:col-span-3 xl:col-span-2">
                    <label for="tags" class="block text-base font-medium text-gray-700">{{"text.job_tags" | translate}}</label>
                    <div class="mt-1" *ngIf="showTag">
                        <tags-component class="mt-1" [options]="tagsOption" (tagsChanged)="changeTags($event)"></tags-component>
                    </div>
                </div>

                <div class="col-span-6" *ngIf="currentCategorySkills?.length > 0">
                    <label for="skills" class="block text-base font-medium text-gray-700">{{"text.job_skills" | translate}}</label>
                    <div class="mt-1">
                        <ng-select
                                [items]="skillOptions"
                                id="skills" 
                                name="skills" 
                                class="form-control"
                                #field_value="ngModel"
                                bindLabel="key"
                                bindValue="value"
                                placeholder="{{'skills.placeholder' | translate}}"
                                appendTo="body"
                                [multiple]="true"
                                [hideSelected]="true"
                                [loading]="lookupLoading"
                                typeToSearchText="{{'info.type_to_search_text' | translate}}"
                                [(ngModel)]="skillValue"
                                [ngModelOptions]="{standalone: true}">
                                >
                        </ng-select>
                    </div>
                </div>

                <div class="col-span-6">
                    <label for="jobDescription" class="block text-base font-medium text-gray-700">{{"text.job_description" | translate}}</label>
                    <div class="h-64 text-base mt-1">
                        <text-editor
                            *ngIf="showEditor"
                            [editorData]="jobForm.get('primaryDetails')?.controls?.jobDescription"
                            [options]="textEditorOptions"
                            style="font-size: 14px;"
                            >
                        </text-editor>
                    </div>
                </div>
            </form>
        </mat-expansion-panel>
    </a>
</ng-template>

<!-- Parts & Services -->
<ng-template #partServiceRef *ngIf="isPartsServicesEnabled">
    <a class="block w-full bg-white border border-gray-200 rounded-lg mt-3">
        <mat-expansion-panel #partsMatExpansionPanel id="parts-service-container" [expanded]="true" class="rounded-lg">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="flex items-center w-full pr-4 pl-2 py-3 sm:pr-3" *ngIf="showPartsBulkAction === true">
                    <div class="flex space-x-2">
                        <span 
                            (click)="revertBulkAction()"
                            class="rounded-full flex justify-center items-center text-gray-600 hover:bg-gray-200 h-8 w-8 cursor-pointer">
                            <i class="ti ti-x text-xl"></i>
                        </span>
                        <span 
                            class="flex justify-center items-center text-base primary-font">
                            {{selectedProductCount}} {{'text.selected' | translate}}
                        </span>
                    </div>
                    <div class="flex item-center space-x-2 ml-auto">
                        <ng-container>
                            <a mat-stroked-button [matMenuTriggerFor]="editPart" (click)="$event?.stopPropagation() "
                                class="inline-flex items-center px-4 py-3 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                                <em class="text-xl" class="ti ti-pencil"></em><span
                                    class="ml-2 primary-font text-base leading-loose pt-0.5">{{"edit" |
                                    translate}}</span>
                             </a>
                            <mat-menu #editPart="matMenu">
                                <ng-container *ngFor="let action of partsBulkActions">
                                    <button class="text-base primary-font h-10" mat-menu-item (click)="performPartsBulkAction(action)">
                                        <em class="text-xl" [class]="action?.icon"></em><span
                                        class="ml-2 primary-font text-base leading-loose pt-0.5">{{action?.displayKey |
                                        translate}}</span>
                                    </button>
                                </ng-container>
                            </mat-menu>
                        </ng-container>
                        <ng-container>
                            <a mat-stroked-button
                                class="inline-flex items-center px-4 py-3 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-red-700 bg-white hover:bg-gray-50 focus:outline-none" (click)="$event?.stopPropagation();performPartsBulkAction({'action':'DELETE_PRODUCTS'})">
                                <em class="text-xl" class="ti ti-trash"></em><span
                                    class="ml-2 primary-font text-base leading-loose pt-0.5">{{"text.remove" |
                                    translate}}</span>
                             </a>
                        </ng-container>
                    </div>
                </div>
                <div class="my-4 flex items-center justify-between w-full text-lg text-gray-700" *ngIf="showPartsBulkAction === false">
                    <h5 class="flex items-center">
                        <i class="ti ti-box text-2xl"></i>
                        <span class="ml-3 font-semibold">
                            {{'part.title.label' | translate}}
                        </span>
                    </h5>
                    <div class="flex item-center" id="pricelist-ng-select">
                      <ng-container *ngIf="isPricelistEnabled">
                        <ng-select
                          #pricelistSelect
                          class="w-60 mr-2 pricelist-select z-20"
                          [formControl]="pricelistFormControl"
                          bindLabel="pricelist_name"
                          bindValue="pricelist_uid"
                          placeholder="{{'text.select_pricelist' | translate}}"
                          appendTo="#parts-service-container"
                          [items]="pricelist | async"
                          [multiple]="false"
                          [loading]="isPricelistFetching"
                          [closeOnSelect]="true"
                          [typeahead]="pricelistValueSubject"
                          (search)="onPricelistSearch()"
                          (scrollToEnd)="onPricelistScrollToEnd()"
                          (close)="onPricelistDropdownClose()"
                          (click)="$event.preventDefault(); $event.stopPropagation(); scrollIntoView();partsMatExpansionPanel.open()"
                          (change)="changePricelist($event);pricelistSelect.blur();">
                          <ng-template ng-option-tmp let-item="item">
                              <div class="primary-font text-base text-gray-600">
                                  <p class="font-semibold">
                                      {{item?.pricelist_name}}
                                  </p>
                                  <div *ngIf="item?.pricelist_type === 'FIXED_DISCOUNT' || item?.pricelist_type === 'FIXED_MARGIN'">
                                       <p>{{item?.pricelist_type === 'FIXED_DISCOUNT' ? ('text.discount' | translate): ''}} {{item?.pricelist_type === 'FIXED_MARGIN' ? ('text.margin' | translate): ''}} - {{item?.pricelist_value_type === 'AMOUNT' ? (item.pricelist_value | currencyFormat) : ''}} {{item?.pricelist_value_type === 'PERCENTAGE' ? (item.pricelist_value + '%') : ''}}</p>
                                  </div>
                                  <p *ngIf="item?.pricelist_type === 'PER_ITEM'">
                                      {{'text.per_item' | translate}}
                                  </p>
                              </div>
                          </ng-template>
                      </ng-select>
                      </ng-container>

                    <!-- <ng-container *ngIf="isProjectRestricted">
                        <a mat-stroked-button (click)="addLineItems($event,'add_item');$event.preventDefault(); $event.stopPropagation()"
                            class="inline-flex items-center px-4 py-3 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                            <em class="text-xl" class="ti ti-plus"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{"add.text" |
                                translate}}</span>
                        </a>
                    </ng-container> -->
                    
                    <ng-container>
                        <a mat-stroked-button [matMenuTriggerFor]="addPartsMenu" (click)="$event.preventDefault(); $event.stopPropagation()"
                            class="inline-flex items-center px-4 py-3 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                            <em class="text-xl" class="ti ti-plus"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{"add.text" |
                                translate}}</span>
                        </a>
                        <mat-menu #addPartsMenu="matMenu">
                            <button class="text-base primary-font h-10" mat-menu-item (click)="addLineItems($event, 'add_item')">
                                <span>{{'line_item.text' | translate}}</span>
                            </button>
                            <button class="text-base primary-font h-10" mat-menu-item (click)="addLineItems($event, 'add_bundle')">
                                <span>{{'text.bundle' | translate}}</span>
                            </button>
                            <button class="text-base primary-font h-10" mat-menu-item (click)="addLineItems($event, 'add_header')" *ngIf="selectedProject?.length === 0">
                                <span>{{'invoice.item.header' | translate}}</span>
                            </button>
                            <button class="text-base primary-font h-10" mat-menu-item (click)="addLineItems($event, 'add_group')" *ngIf="!isProjectRestricted">
                                <span>{{'job.details.pick_parts_menu.item_group' | translate}}</span>
                            </button>
                            <button class="text-base primary-font h-10" mat-menu-item (click)="addLineItems($event, 'add_custom_item')" *ngIf="!isProjectRestricted">
                                <span>{{'job.details.pick_parts_menu.custom_line_item' | translate}}</span>
                            </button>
                        </mat-menu>
                    </ng-container>

                    </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
                <div class="p-6 flex flex-col items-center justify-center" *ngIf="!selectedLineItems?.length">
                    <img src="/assets/images/svgs/no_parts_found.svg" class="h-32" alt="">
                    <h5 class="text-xl font-semibold py-1 mt-2">{{"product.button.add_customers" | translate}}</h5>
                    <p class="text-base">{{"job.details.add_any_products_to_job" | translate}}</p>
                </div>
                <div class="flex flex-col flex-auto hover-stripped" *ngIf="selectedLineItems?.length">
                    <app-line-item-list [module]="'JOB'"  [lineitemData]="selectedLineItems" [lineItemColumns]="lineItemsDisplayedColumns" (productOrderChange)="updateLineItemsOrder($event)" (productEventEmitted)="performPartsAction($event?.action, $event?.product, $event?.index, $event?.type)"></app-line-item-list>
                </div>
        </mat-expansion-panel>
    </a>
</ng-template>



<!-- Service Task -->
<ng-template #serviceTaskRef *ngIf="isServiceTaskEnabled">
    <a class="block w-full bg-white border border-gray-200 rounded-lg mt-3">
        <mat-expansion-panel  [expanded]="true" class="rounded-lg">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h5 class="my-4 flex items-center justify-between w-full text-lg font-semibold text-gray-700">
                    <div class="flex items-center">
                        <i class="ti ti-list-check text-2xl"></i>
                        <span class="ml-3">
                            {{'title.tasks.service_tasks' | translate}}
                        </span>
                    </div>
                    
                    <div class="ml-auto flex items-center">
                        <div class="inline-flex rounded-md shadow-sm mr-3" role="group" *ngIf="selectedServiceTask?.length">
                            <button 
                                type="button" 
                                title="{{'task.order.serial_execution' | translate}}" 
                                class="inline-flex items-center px-2 py-1.5 text-sm font-medium text-gray-900 bg-white border border-gray-300 border-r-0 rounded-l-lg hover:bg-gray-100"
                                [ngClass]="{'bg-gray-200': currentExecution === 'SERIES'}"
                                (click)="selectExecutionType($event, 'SERIES')"
                                >
                                <i class="ti ti-sort-descending text-2xl"></i>
                            </button>
                            <button 
                                type="button" 
                                title="{{'task.order.parallel_execution' | translate}}" 
                                class="inline-flex items-center px-2 py-1.5 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-r-md hover:bg-gray-100"
                                [ngClass]="{'bg-gray-200': currentExecution === 'PARALLEL'}"
                                (click)="selectExecutionType($event, 'PARALLEL')"
                                >
                                <i class="ti ti-list text-2xl"></i>
                            </button>
                        </div>

                        <a mat-stroked-button
                            *ngIf="selectedServiceTask?.length"
                            (click)="$event.preventDefault(); $event.stopPropagation();openReorder()"
                            class="inline-flex items-center px-4 py-3 h-9 border border-gray-300 shadow-xs text-xl font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                            <em class="text-xl" class="ti ti-stack"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{"label.reorder" | translate}}</span>
                        </a>

                        <a mat-stroked-button [matMenuTriggerFor]="addTaskMenu"
                            (click)="$event.preventDefault(); $event.stopPropagation()"
                            class="inline-flex items-center px-4 py-3 h-9 mx-3 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                            <em class="text-xl" class="ti ti-plus"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{"add.text" |
                                translate}}</span>
                        </a>
                        <mat-menu #addTaskMenu="matMenu">
                            <button class="text-base primary-font h-10" mat-menu-item (click)="addServiceTask($event)">
                                <span>{{'label.service_task' | translate}}</span>
                            </button>
                            <button class="text-base primary-font h-10" mat-menu-item (click)="createCustomTask('serviceTaskDrawer')">
                                <span>{{'label.custom_task' | translate}}</span>
                            </button>
                        </mat-menu>
                        
                        <a mat-stroked-button
                            *ngIf="selectedServiceTask?.length"
                            (click)="$event.preventDefault(); $event.stopPropagation();clearAllTask()"
                            class="inline-flex items-center px-4 py-3 h-9 border border-gray-300 shadow-xs text-xl font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 ">
                            <em class="text-xl" class="ti ti-trash"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{"task.button.clear_all" | translate}}</span>
                        </a>
                    </div>
                </h5>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="p-6 flex flex-col items-center justify-center"  *ngIf="!selectedServiceTask?.length">
                <img src="/assets/images/svgs/no_parts_found.svg" class="h-32" alt="">
                <h5 class="text-xl font-semibold py-1 mt-2">{{"placeholder.title.add_service_task" | translate}}</h5>
                <p class="text-base">{{"placeholder.description.service_task" | translate}}</p>
            </div>
            <div class="flex flex-col flex-auto hover-stripped overflow-auto zuper-scrollbar" *ngIf="selectedServiceTask?.length">
                <table mat-table [dataSource]="selectedServiceTask" aria-describedby="jobDetails">
                    <!-- No Column -->
                    <ng-container matColumnDef="checkbox">
                        <th mat-header-cell *matHeaderCellDef class="pr-2">  </th>
                        <td class="text-base pr-2 py-3 " style="width: 50px;" mat-cell *matCellDef="let element; let i = index"> 
                            {{i+1}}
                        </td>
                    </ng-container>
                
                    <!-- Service Task -->
                    <ng-container matColumnDef="service_task">
                        <th mat-header-cell *matHeaderCellDef class="pr-2"> {{"label.service_task" | translate}} </th>
                        <td class="text-base pr-2 py-3 font-semibold cursor-pointer" style="min-width: 120px;" mat-cell *matCellDef="let element; let index = index">
                            {{element?.service_task_title}}
                        </td>
                    </ng-container>
    
                    <!-- Description -->
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef class="px-2"> {{"description" | translate}} </th>
                        <td class="text-base px-2 py-3" mat-cell *matCellDef="let element"> 
                          <p class="w-48 text-ellipsis truncate overflow-hidden" [title]="element?.service_task_description">
                              {{element?.service_task_description}}
                          </p> 
                        </td>
                    </ng-container>
    
                    <!-- Inspection Form -->
                    <ng-container matColumnDef="inspection_form">
                        <th mat-header-cell *matHeaderCellDef class="px-2"> {{"label.inspection_form" | translate}} </th>
                        <td class="text-base px-2 py-3" mat-cell *matCellDef="let element"> {{element?.inspection_form?.asset_form_name}}</td>
                    </ng-container>
                
                    <!-- Estimated Duration -->
                    <ng-container matColumnDef="estimated_duration">
                        <th mat-header-cell *matHeaderCellDef class="px-2"> {{"label.estimated_duration" | translate}}</th>
                        <td class="text-base px-4 py-3" mat-cell *matCellDef="let element">
                            <span *ngIf="element?.estimated_duration?.days">{{element?.estimated_duration?.days}}d</span>
                            <span *ngIf="element?.estimated_duration?.hours"> {{element?.estimated_duration?.hours}}h</span>
                            <span *ngIf="element?.estimated_duration?.minutes"> {{element?.estimated_duration?.minutes}}m</span>
                        </td>
                    </ng-container>

                    <!-- Asset -->
                    <ng-container matColumnDef="asset">
                        <th mat-header-cell *matHeaderCellDef class="px-2"> {{"asset.text" | translate}}</th>
                        <td class="text-base px-2 py-3 " mat-cell *matCellDef="let element; let i = index">
                            <span class="cursor-pointer text-primary" (click)="toggleTaskAsset(element, i)" *ngIf="!serviceTaskAssets[i]">{{"label.link_asset" | translate}}</span>
                            <!-- <span >{{serviceTaskAssets[element?.service_task_master_uid]['asset_name']}}</span> -->
                            <div *ngIf="serviceTaskAssets[i]">
                                <p class="flex items-center">
                                    {{serviceTaskAssets[i]['asset_name']}}
                                    <span 
                                        title="{{'text.edit_asset' | translate}}"
                                        (click)="toggleTaskAsset(element, i)"
                                        class="rounded-full flex justify-center items-center text-gray-600 hover:bg-gray-200 h-6 w-6 ml-2 p-1 cursor-pointer">
                                        <i class="ti ti-pencil text-2xl p-1 rounded-full hover:bg-gray-200"></i>
                                    </span>
                                    <span 
                                        title="{{'text.remove_asset' | translate}}"
                                        (click)="removeTaskAsset(i)"
                                        class="rounded-full flex justify-center items-center text-red-600 hover:bg-red-200 h-6 w-6 p-1 cursor-pointer">
                                        <i class="ti ti-trash text-2xl p-1 rounded-full hover:bg-red-200"></i>
                                    </span>
                                </p>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Assign employee -->
                    <ng-container matColumnDef="assign">
                        <th mat-header-cell *matHeaderCellDef class="px-2 text-center"> {{"text.assign_users" | translate}}</th>
                        <td class="text-base text-center px-2 py-3" mat-cell *matCellDef="let element; let i = index">
                            <i 
                                *ngIf="!element?.assigned_to?.user?.first_name"
                                class="ti ti-user text-lg border rounded-full border-gray-200 p-3" 
                                (click)="assignEmployeeForTask(i, element)" 
                                [ngxTippy]="assigEmployeeToTask"
                                [tippyProps]="{
                                allowHTML: true,
                                theme: 'light',
                                trigger:'click',
                                hideOnClick: true,
                                interactive: true,
                                placement: 'bottom',
                                appendTo: tippyTargetEle
                                }"
                            ></i>
                            <img 
                                (click)="assignEmployeeForTask(i, element)" 
                                *ngIf="element?.assigned_to?.user?.first_name" 
                                [src]="element?.assigned_to?.user?.profile_picture" 
                                title="{{element?.assigned_to?.user?.first_name}} {{element?.assigned_to?.user?.last_name}}" 
                                class="w-8 h-8 mx-auto rounded-full" 
                                alt=""
                                [ngxTippy]="assigEmployeeToTask"
                                [tippyProps]="{
                                allowHTML: true,
                                theme: 'light',
                                trigger:'click',
                                hideOnClick: true,
                                interactive: true,
                                placement: 'bottom',
                                appendTo: tippyTargetEle
                                }"
                                >
                        </td>
                    </ng-container>
                        
                    <!-- Action -->
                    <ng-container matColumnDef="action" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef class="px-2">
                            {{"actions.text" | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element ; let i = index" class="justify-start items-start px-2 py-2 ">
                            <div class="inline-flex items-center py-3 mr-1">
                                <button [matMenuTriggerFor]="actionMenu" mat-icon-button class="inline-flex items-center rounded-full border border-transparent text-black p-4" [ngClass]=""><em class="ti ti-dots text-xl mt-0.5 mr-0.5"></em></button>
                                <mat-menu #actionMenu="matMenu">
                                  <div mat-menu-item class="primary-font text-base h-10" (click)="performTaskAction('clone',element, i)">
                                    <div class="flex items-center space-x-2">
                                        <div class="menu-item-drag">
                                            <em class="ti ti-copy text-xl"></em>
                                        </div>
                                        <div class="primary-font text-base text-gray-700">
                                            <span>{{'tooltip.clone_task' | translate}}</span>
                                        </div>
                                    </div>
                                  </div>
                                  <div mat-menu-item class="primary-font text-base h-10" (click)="performTaskAction('edit',element,i)">
                                    <div class="flex items-center space-x-2">
                                        <div class="menu-item-drag">
                                            <em class="ti ti-edit text-xl"></em>
                                        </div>
                                        <div class="primary-font text-base text-gray-700">
                                            <span>{{'text.edit_task' | translate}}</span>
                                        </div>
                                    </div>
                                  </div>
                                  <div mat-menu-item class="primary-font text-base h-10" (click)="performTaskAction('remove',element,i)">
                                    <div class="flex items-center text-red-600 space-x-2">
                                        <div class="menu-item-drag">
                                            <em class="ti ti-trash text-xl"></em>
                                        </div>
                                        <div class="primary-font text-base text-red-600">
                                            <span>{{'label.remove_task' | translate}}</span>
                                        </div>
                                    </div>
                                  </div>
                                </mat-menu>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row class="bg-gray-50" *matHeaderRowDef="taskDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: taskDisplayedColumns;"></tr>
                </table>
            </div>
            <div class="w-full my-3 text-base px-4" *ngIf="selectedServiceTask?.length">
                <p class="flex items-center space-x-2">
                    <span class="flex items-center" *ngIf="jobScheduleDuration?.days || jobScheduleDuration?.hours || jobScheduleDuration?.minutes">
                        {{"label.scheduled_duration" | translate}}
                        <i class="ti ti-arrow-narrow-right mx-1 text-lg"></i>
                        <i class="ti ti-clock text-lg"></i>
                        <span class="px-2 border-r border-gray-200">
                            <span *ngIf="jobScheduleDuration?.days" class="mx-0.5">{{jobScheduleDuration?.days}}d</span>
                            <span *ngIf="jobScheduleDuration?.hours" class="mx-0.5">{{jobScheduleDuration?.hours}}h</span>
                            <span *ngIf="jobScheduleDuration?.minutes" class="mx-0.5">{{jobScheduleDuration?.minutes}}m</span>
                        </span>
                    </span>
                    <span class="flex items-center" *ngIf="serviceTaskDuration?.days || serviceTaskDuration?.hours || serviceTaskDuration?.minutes">
                        {{"label.service_task_duration" | translate}}
                        <i class="ti ti-arrow-narrow-right mx-1 text-lg"></i>
                        <i class="ti ti-clock text-lg"></i>
                        <span class="px-2">
                            <span *ngIf="serviceTaskDuration?.days" class="mx-0.5">{{serviceTaskDuration?.days}}d</span>
                            <span *ngIf="serviceTaskDuration?.hours" class="mx-0.5">{{serviceTaskDuration?.hours}}h</span>
                            <span *ngIf="serviceTaskDuration?.minutes" class="mx-0.5">{{serviceTaskDuration?.minutes}}m</span>
                        </span>
                    </span>
                </p>
            </div>
            <div class="rounded-md bg-orange-50 w-full px-4 py-3" *ngIf="showScheduleDurationAlert() && selectedServiceTask?.length && showSkip">
                <div class="flex justify-between">
                    <div class="flex items-center">
                        <div class="flex-shrink-0">
                            <i class="ti ti-alert-circle text-orange-700 text-2xl"></i>
                        </div>
                        <div class="ml-3 flex-1 md:flex md:justify-between">
                            <p class="text-base text-orange-700">{{"alert.exceeded_scheduled_duration" | translate}}</p>
                        </div>
                    </div>
                    <div>
                        <span class="mx-2 text-base text-orange-700 font-semibold cursor-pointer" (click)="showSkip = false">{{"button.label.skip" | translate}}</span>
                        <span class="mx-2 text-base text-orange-700 font-semibold cursor-pointer" (click)="rescheduleJob()">{{"text.reschedule" | translate}}</span>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </a>
</ng-template>

<!-- Custom Fields  -->
<ng-template #customFieldRef >
    <app-custom-field-form *ngIf="showCustomFields" [config]="customFieldConfig" [formGroup]="jobForm.controls?.customFields" [fieldValue]="customFieldValue" [category]="currentCategoryId"></app-custom-field-form>
</ng-template>

<!-- Assign Users -->
<ng-template #assignUserRef>
    <a class="block w-full bg-white border-b border-gray-200">
        <mat-expansion-panel  [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h5 class="my-4 flex items-center justify-between w-full text-lg font-semibold text-gray-700">
                    <div class="flex items-center">
                        <i class="ti ti-map-2 text-2xl"></i>
                        <span class="ml-3">
                            {{"text.assign_users" | translate}}
                        </span>
                        <span class="ml-1" *ngIf="assignEmployeeOptions['details']?.['assigned_to']?.length">
                            ({{assignEmployeeOptions['details']['assigned_to'].length}})
                        </span>
                    </div>
                    <div *ngIf="assignEmployeeOptions['details']?.['assigned_to']?.length > 0">
                        <i class="ti ti-plus text-2xl p-1 rounded-full hover:bg-gray-200" (click)="$event.preventDefault();$event.stopPropagation();toggleAssignmentDrawer('assignEmployeeDrawer')"></i>
                    </div>
                </h5>
              </mat-panel-title>
            </mat-expansion-panel-header>
                <div class="p-6 flex flex-col items-center justify-center" *ngIf="assignEmployeeOptions['details']['assigned_to']?.length === 0">
                    <img src="/assets/images/svgs/add_customer_placeholder.svg" class="h-32" alt="">
                    <a mat-stroked-button
                            (click)="toggleAssignmentDrawer('assignEmployeeDrawer')"
                            class="inline-flex items-center px-4 py-3 mt-4 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                            <em class="text-xl" class="ti ti-plus"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{'text.assign_users' | translate}}</span>
                    </a>
                </div>
                <ng-container *ngIf="assignEmployeeOptions['details']['assigned_to']?.length > 0">
                    <div class="flex px-4 py-3 justify-between" [ngClass]="{'border-b': i !== assignEmployeeOptions['details']['assigned_to']?.length - 1}" *ngFor="let data of this.assignEmployeeOptions['details']['assigned_to']; let i = index">
                        <div class="flex">
                            <div class="relative flex flex-0 items-center justify-center w-12 h-12 self-center">
                                <ng-container *ngIf="data?.user?.profile_picture">
                                    <img
                                        class="w-full h-full rounded-md object-cover"
                                        [src]="data?.user?.profile_picture"
                                        alt="Contact avatar"/>
                                </ng-container>
                                <ng-container *ngIf="!data?.user?.profile_picture">
                                    <div class="flex items-center justify-center w-full h-full rounded-full text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                        {{data?.user?.first_name?.charAt(0)}}
                                    </div>
                                </ng-container>
                            </div>
                            <div class="min-w-0 ml-4">
                                <div class="flex">
                                    <div class="leading-5 truncate">
                                        <span class="font-medium text-base pr-2">{{data?.user?.first_name}} {{data?.user?.last_name}}</span>
                                    </div>  
                                    <div class="w-2/12 flex items-center justify-center cursor-pointer" [matTooltip]="'text.primary.employee' | translate" *ngIf="data?.is_primary && utilityService?.companyPolicy?.enable_v2_timelog &&  companyConfig?.jobs?.job_timelog?.is_enabled">
                                        <mat-icon class="min-h-5 min-w-5 h-5 w-5 text-xl text-orange-700" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                    </div>
                                </div>
                                <div class="flex">
                                    <p *ngIf="data?.user?.role?.role_name" class="mt-0.5 text-base pr-3 border-r border-gray-300">{{data?.user?.role?.role_name}}</p>                  
                                    <p *ngIf="data?.team?.team_name" class="px-3 text-base mt-0.5">{{data?.team?.team_name}}</p>
                                </div>    
                            </div>
                        </div>
                        <div class="w-2/12 flex items-center justify-end" [matTooltip]="'text.unassign' | translate" (click)="unassignUser(i)">
                            <em class="text-xl text-red-500 ti ti-user-x"></em>
                        </div>
                    </div>
                </ng-container>
        </mat-expansion-panel>
    </a>
</ng-template>

<!-- Organization -->
<ng-template #organizationRef *ngIf="utilityService.hasModuleAccess('ORGANIZATION')">
    <a class="block w-full bg-white border-b border-gray-200">
        <mat-expansion-panel  [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h5 class="my-4 flex items-center justify-between w-full text-lg font-semibold text-gray-700">
                        <div class="flex items-center">
                            <i class="ti ti-building text-2xl"></i>
                            <span class="ml-3">
                                {{"text.organization" | translate}}
                            </span>
                        </div>
                        <div *ngIf="!selectedOrganizations.length">
                            <i class="ti ti-exclamation-circle text-2xl my-3 text-red-500" *ngIf="showInvalidIcon('organization')"></i>
                        </div>
                        <div *ngIf="selectedOrganizations.length">
                            <i class="ti ti-trash text-red-500 text-2xl p-1 rounded-full hover:bg-red-200" title="{{'tooltip.remove.organization' | translate}}" (click)="$event.preventDefault();$event.stopPropagation();removeOrganization()"></i>
                        </div>
                    </h5>
                </mat-panel-title>
            </mat-expansion-panel-header>
                <div class="p-6 flex flex-col items-center justify-center" *ngIf="!selectedOrganizations.length">
                    <img src="/assets/images/svgs/attachment_placeholder.svg" class="h-32" alt="">
                    <a mat-stroked-button
                            (click)="toggleOrganization()"
                            class="inline-flex items-center px-4 py-3 mt-4 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                            <em class="text-xl" class="ti ti-plus"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{'organization.header.add' | translate}}</span>
                    </a>
                </div>
                <ng-container *ngIf="selectedOrganizations.length">
                    <div class="flex px-4 py-3 justify-between">
                        <div class="flex w-10/12">
                            <div class="relative flex flex-0 items-center justify-center w-12 h-12 self-center">
                                <ng-container *ngIf="selectedOrganizations[0]?.organization_logo">
                                    <img
                                        class="w-full h-full rounded object-cover"
                                        [src]="selectedOrganizations[0]?.organization_logo"
                                        alt="Contact avatar"/>
                                </ng-container>
                                <ng-container *ngIf="!selectedOrganizations[0]?.organization_logo">
                                    <div class="flex items-center justify-center w-full h-full rounded text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                        {{selectedOrganizations[0]?.organization_name?.charAt(0)}}
                                    </div>
                                </ng-container>
                            </div>
                            <div class="min-w-0 ml-4 w-2/3">
                                <div class="leading-5 truncate">
                                    <span class="font-semibold text-lg text-base pr-2 truncate">{{selectedOrganizations[0]?.organization_name}}</span>
                                </div>      
                                <p *ngIf="selectedOrganizations[0]?.organization_email" class="mt-0.5 text-base truncate">{{selectedOrganizations[0]?.organization_email}}</p>                  
                            </div>
                        </div>
                        <div class="w-2/12 flex items-center justify-end">
                            <a href="mailto:{{selectedOrganizations[0]?.organization_email}}" *ngIf="selectedOrganizations[0]?.organization_email" class="cursor-pointer">
                                <em class="text-3xl ti ti-mail"></em>
                            </a>
                        </div>
                    </div>
                    <div class="px-4 pb-3">
                        <div class="flex mt-1">
                            <div
                                class="flex flex-shrink-0 bg-gray-200 rounded-full items-center justify-center h-7 w-7">
                                <em class="ti ti-user text-xl"></em>
                            </div>
                            <div class="flex min-w-0 ml-3 space-y-1 text-base">
                                <div class="flex items-center leading-6 truncate">
                                    {{selectedOrganizations[0]?.no_of_customers}} {{"customers.text" | translate}}
                                </div>
                            </div>
                        </div>
                        <div class="flex mt-2">
                            <div
                                class="flex flex-shrink-0 bg-gray-200 rounded-full items-center justify-center h-7 w-7">
                                <em class="ti ti-map-pin text-xl"></em>
                            </div>
                            <div class="flex min-w-0 ml-3 space-y-1 text-base">
                                <div class="flex items-center leading-6">
                                    {{selectedOrganizations[0]?.organization_address?.street}}
                                    {{(selectedOrganizations[0]?.organization_address?.city) ? ", "+selectedOrganizations[0].organization_address.city : ''}}
                                    {{(selectedOrganizations[0]?.organization_address?.state) ? ", "+selectedOrganizations[0].organization_address.state : ''}}
                                    {{(selectedOrganizations[0]?.organization_address?.country) ? ", "+selectedOrganizations[0].organization_address.country : ''}}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
        </mat-expansion-panel>
    </a>
</ng-template>

<!-- Customer -->
<ng-template #customerRef *ngIf="utilityService.hasModuleAccess('CUSTOMER')">
    <a class="block w-full bg-white border-b border-gray-200">
        <mat-expansion-panel  [expanded]="true">
            <mat-expansion-panel-header>
            <mat-panel-title>
                <h5 class="my-4 flex items-center justify-between w-full text-lg font-semibold text-gray-700">
                    <div class="flex items-center">
                        <i class="ti ti-user text-2xl"></i>
                        <span class="ml-3">
                            {{"customer" | translate}}
                        </span>
                    </div>
                    <div *ngIf="!selectedCustomers.length">
                        <i class="ti ti-exclamation-circle text-2xl my-3 text-red-500" *ngIf="showInvalidIcon('customer')"></i>
                    </div>
                    <div *ngIf="selectedCustomers.length">
                        <i class="ti ti-trash text-red-500 text-2xl p-1 rounded-full hover:bg-red-200" title="{{'text.remove_customer' | translate}}" (click)="$event.preventDefault();$event.stopPropagation();removeCustomer()"></i>
                    </div>
                </h5>
            </mat-panel-title>
            </mat-expansion-panel-header>
                <div class="p-6 flex flex-col items-center justify-center"  *ngIf="!selectedCustomers.length">
                    <img src="/assets/images/svgs/customer_placeholder.svg" class="h-32" alt="">
                    <a mat-stroked-button
                            (click)="toggleCustomer()"
                            class="inline-flex items-center px-4 py-3 mt-4 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                            <em class="text-xl" class="ti ti-plus"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{'maps.organization_popup.add_customer' | translate}}</span>
                    </a>
                </div>
                <div class="rounded-md bg-orange-50 px-4 py-3" *ngIf="selectedCustomers.length && selectedCustomers[0]?.accounts?.receivables && companyConfig?.customers?.show_bad_debt_alert">
                    <div class="flex">
                        <div class="flex-shrink-0">
                        <i class="ti ti-alert-circle text-orange-700 text-2xl"></i>
                        </div>
                        <div class="ml-3 flex-1 md:flex md:justify-between">
                        <p class="text-base text-orange-700">{{"alert.customer.has_receivable" | translate}} {{selectedCustomers[0]?.accounts?.receivables | currencyFormat}}</p>
                        </div>
                    </div>
                </div>
                <div class="rounded-md bg-blue-50 px-4 py-3" *ngIf="selectedCustomers.length && (selectedCustomers[0]?.sla_duration?.days || selectedCustomers[0]?.sla_duration?.hours || selectedCustomers[0]?.sla_duration?.minutes)">
                    <div class="flex">
                        <div class="flex-shrink-0">
                        <i class="ti ti-alert-circle text-blue-700 text-2xl"></i>
                        </div>
                        <div class="ml-3 flex-1 md:flex md:justify-between">
                        <p class="text-base text-blue-700">{{"alert.customer.sla_duration" | translate}} 
                            <span *ngIf="selectedCustomers[0]?.sla_duration?.days">{{selectedCustomers[0]?.sla_duration?.days}} 
                                <span *ngIf="selectedCustomers[0]?.sla_duration?.days > 1" class="lowercase">{{"text.days" | translate}}</span>
                                <span *ngIf="selectedCustomers[0]?.sla_duration?.days === 1" class="lowercase">{{"text.day" | translate}}</span>
                            </span> 
                            
                            <span *ngIf="selectedCustomers[0]?.sla_duration?.hours"> {{selectedCustomers[0]?.sla_duration?.hours}} 
                                <span *ngIf="selectedCustomers[0]?.sla_duration?.hours > 1">{{"label.hours" | translate}}</span>
                                <span *ngIf="selectedCustomers[0]?.sla_duration?.hours === 1">{{"label.hour" | translate}}</span>
                            </span> 
                            
                            <span *ngIf="selectedCustomers[0]?.sla_duration?.minutes"> {{selectedCustomers[0]?.sla_duration?.minutes}} 
                                <span *ngIf="selectedCustomers[0]?.sla_duration?.minutes > 1">{{"label.minutes" | translate}}</span>
                                <span *ngIf="selectedCustomers[0]?.sla_duration?.minutes === 1">{{"label.minute" | translate}}</span>
                            </span>
                        </p>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="selectedCustomers.length">
                    <div class="flex px-4 py-3 justify-between">
                        <div class="flex w-10/12">
                            <div class="relative flex flex-0 items-center justify-center w-12 h-12 self-center">
                                <ng-container>
                                    <div class="flex items-center justify-center w-full h-full rounded text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                        {{selectedCustomers[0]?.customer_first_name?.charAt(0)}}
                                    </div>
                                </ng-container>
                            </div>
                            <div class="min-w-0 ml-4 w-2/3">
                                <div class="leading-5 truncate">
                                    <p class="font-semibold text-lg text-base pr-2 truncate text-ellipsis">{{selectedCustomers[0]?.customer_first_name}} {{selectedCustomers[0]?.customer_last_name}}</p>
                                </div>      
                                <p *ngIf="selectedCustomers[0]?.customer_email" class="mt-0.5 text-base truncate">{{selectedCustomers[0]?.customer_email}}</p>                  
                            </div>
                        </div>
                        <div class="w-2/12 flex items-center justify-end">
                            <a href="mailto:{{selectedCustomers[0]?.customer_email}}" *ngIf="selectedCustomers[0]?.customer_email" class="cursor-pointer">
                                <em class="text-3xl ti ti-mail"></em>
                            </a>
                            <a 
                                href="tel:{{selectedCustomers[0]?.customer_contact_no?.mobile ?? selectedCustomers[0]?.customer_contact_no?.home ?? selectedCustomers[0]?.customer_contact_no?.work}}" 
                                *ngIf="selectedCustomers[0]?.customer_contact_no?.mobile ?? selectedCustomers[0]?.customer_contact_no?.home ?? selectedCustomers[0]?.customer_contact_no?.work"
                                class="cursor-pointer ml-4">
                                <em class="text-3xl ti ti-phone"></em>
                            </a>
                        </div>
                    </div>
                    <div class="px-4 pb-3">
                        <div class="flex mt-1" *ngIf="selectedCustomers[0]?.customer_organization?.organization_name">
                            <div
                                class="flex flex-shrink-0 bg-gray-200 rounded-full items-center justify-center h-7 w-7">
                                <em class="ti ti-building text-xl"></em>
                            </div>
                            <div class="flex min-w-0 ml-3 space-y-1 text-base">
                                <div class="flex items-center leading-6 truncate">
                                    {{selectedCustomers[0]?.customer_organization?.organization_name}}
                                </div>
                            </div>
                        </div>
                        <div class="flex mt-2" *ngIf="selectedCustomers[0]?.customer_address?.street">
                            <div
                                class="flex flex-shrink-0 bg-gray-200 rounded-full items-center justify-center h-7 w-7">
                                <em class="ti ti-map-pin text-xl"></em>
                            </div>
                            <div class="flex min-w-0 ml-3 space-y-1 text-base">
                                <div class="flex items-center leading-6">
                                    {{selectedCustomers[0]?.customer_address?.street}}
                                    {{(selectedCustomers[0]?.customer_address?.city) ? ", "+selectedCustomers[0].customer_address.city : ''}}
                                    {{(selectedCustomers[0]?.customer_address?.state) ? ", "+selectedCustomers[0].customer_address.state : ''}}
                                    {{(selectedCustomers[0]?.customer_address?.country) ? ", "+selectedCustomers[0].customer_address.country : ''}}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
        </mat-expansion-panel>
    </a>
</ng-template>
<!-- Secondary Contacts -->
<ng-template #secondaryContactsRef *ngIf="(utilityService.hasModuleAccess('ORGANIZATION') || utilityService.hasModuleAccess('CUSTOMER')) && this.companyConfig?.jobs?.secondary_customers?.is_enabled">
    <a class="block w-full bg-white border-b border-gray-200">
        <mat-expansion-panel  [expanded]="true">
            <mat-expansion-panel-header>
            <mat-panel-title>
                <h5 class="my-4 flex items-center justify-between w-full text-lg font-semibold text-gray-700">
                    <div class="flex items-center">
                        <i class="ti ti-user text-2xl"></i>
                        <span class="ml-3">
                            {{"text.secondary_contacts" | translate}}
                        </span>
                        <span class="ml-1" *ngIf="selectedSecondaryContacts?.length">
                            ({{selectedSecondaryContacts.length}})
                        </span>
                    </div>
                    <div>
                        <button type="button" class="relative" mat-icon-button
                            title="{{'text.edit_secondary_contacts' | translate}}" *ngIf="selectedSecondaryContacts?.length"
                            (click)="toggleSecondaryContacts()">
                            <em class="ti ti-pencil text-2xl"></em>
                        </button>
                    </div>
                </h5>
            </mat-panel-title>
            </mat-expansion-panel-header>
                <div class="rounded-md bg-blue-50 px-4 py-3" *ngIf="disableSecondaryContactField() && !selectedSecondaryContacts?.length">
                    <div class="flex">
                        <div class="flex-shrink-0">
                        <i class="ti ti-alert-circle text-blue-700 text-2xl"></i>
                        </div>
                        <div class="ml-3 flex-1 md:flex md:justify-between">
                        <p class="text-base text-blue-700">{{"alert.customer_or_organization_mandatory" | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="p-6 flex flex-col items-center justify-center"  *ngIf="!selectedSecondaryContacts.length">
                    <img src="/assets/images/svgs/customer_placeholder.svg" class="h-32" alt="">
                    <a mat-stroked-button
                            [disabled]="disableSecondaryContactField()"
                            (click)="toggleSecondaryContacts()"
                            class="inline-flex items-center px-4 py-3 mt-4 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                            <em class="text-xl" class="ti ti-plus"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{'maps.organization_popup.add_secondary_contacts' | translate}}</span>
                    </a>
                </div>
                <ng-container *ngIf="selectedSecondaryContacts?.length > 0">
                    <div class="flex px-4 py-3 justify-between" [ngClass]="{'border-b': i !== selectedSecondaryContacts?.length - 1}"
                        *ngFor="let data of this.selectedSecondaryContacts; let i = index">
                        <div class="flex flex-col w-10/12">
                            <div class="flex">
                                <div>
                                    <div class="inline-flex overflow-hidden rounded-md flex-shrink-0 border-2">
                                        <div *ngIf="data?.customer_first_name"
                                            class="flex items-center justify-center overflow-hidden uppercase text-4xl font-secondary leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 h-10 w-10 flex-shrink-0 sm:h-9 sm:w-9 lg:h-12 lg:w-12">
                                            {{data?.customer_first_name[0]}}
                                        </div>
                                    </div>
                                </div>
                                <div class="sm:ml-3 sm:flex-1 break-all max-w-4/5">
                                    <div class="flex">
                                        <h3 class="text-lg font-bold text-gray-600 sm:text-1xl cursor-not-allowed truncate max-w-3/4"
                                            [matTooltip]="data?.customer_first_name + ' ' + data?.customer_last_name">
                                            {{data?.customer_first_name}} {{data?.customer_last_name}}</h3>
                                    </div>
                                    <div *ngIf="data?.customer_email">
                                        <span class="primary-font text-base text-primary">{{data?.customer_email}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-2/12 flex items-center justify-end" [matTooltip]="'text.remove' | translate" (click)="unassignSecondaryContacts(i)">
                            <em class="text-xl text-red-500 ti ti-user-x"></em>
                        </div>
                  </div>
                </ng-container>
        </mat-expansion-panel>
    </a>
</ng-template>

<!-- Property -->
<ng-template #propertyRef *ngIf="utilityService.hasModuleAccess('PROPERTY')">
    <a class="block w-full bg-white border-b border-gray-200">
        <mat-expansion-panel  [expanded]="true">
            <mat-expansion-panel-header>
            <mat-panel-title>
                <h5 class="my-4 flex items-center justify-between w-full text-lg font-semibold text-gray-700">
                    <div class="flex items-center">
                        <i class="ti ti-building-community text-2xl"></i>
                        <span class="ml-3">
                            {{"text.property" | translate}}
                        </span>
                    </div>
                    <div *ngIf="selectedProperty.length">
                        <i class="ti ti-trash text-red-500 text-2xl p-1 rounded-full hover:bg-red-200" title="{{'tooltip.remove.property' | translate}}" (click)="$event.preventDefault();$event.stopPropagation();removeProperty()"></i>
                    </div>
                </h5>
            </mat-panel-title>
            </mat-expansion-panel-header>
                <div class="rounded-md bg-blue-50 px-4" *ngIf="!selectedProperty.length">
                    <div class="flex">
                    </div>
                </div>
                <div class="p-6 flex flex-col items-center justify-center" *ngIf="!selectedProperty.length">
                    <img src="/assets/images/svgs/attachment_placeholder.svg" class="h-32" alt="">
                    <a mat-stroked-button
                            (click)="toggleProperty()"
                            class="inline-flex items-center px-4 py-3 mt-4 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                            <em class="text-xl" class="ti ti-plus"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{'text.add_property' | translate}}</span>
                    </a>
                </div>
                <ng-container *ngIf="selectedProperty.length">
                    <div class="flex px-4 py-3 justify-between">
                        <div class="flex w-full">
                            <div class="relative flex flex-0 items-center justify-center w-12 h-12 self-center">
                                <ng-container *ngIf="selectedProperty[0]?.property_image">
                                    <img
                                        class="w-full h-full rounded object-cover"
                                        [src]="selectedProperty[0]?.property_image"
                                        alt="Contact avatar"/>
                                </ng-container>
                                <ng-container *ngIf="!selectedProperty[0]?.property_image">
                                    <div class="flex items-center justify-center w-full h-full rounded text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                        {{selectedProperty[0]?.property_name?.charAt(0)}}
                                    </div>
                                </ng-container>
                            </div>
                            <div class="min-w-0 ml-4">
                                <div class="leading-5 truncate">
                                    <span class="font-semibold text-lg text-base pr-2">{{selectedProperty[0]?.property_name}}</span>
                                </div>      
                                <p class="mt-0.5 text-base">{{selectedProperty[0]?.no_of_jobs}} {{"text.jobs" | translate}}</p>                  
                            </div>
                        </div>
                    </div>
                    <div class="px-4 pb-3">
                        <div class="flex mt-2" *ngIf="selectedProperty[0]?.property_address?.street">
                            <div
                                class="flex flex-shrink-0 bg-gray-200 rounded-full items-center justify-center h-7 w-7">
                                <em class="ti ti-map-pin text-xl"></em>
                            </div>
                            <div class="flex min-w-0 ml-3 space-y-1 text-base">
                                <div class="flex items-center leading-6">
                                    {{selectedProperty[0]?.property_address?.street}}
                                    {{(selectedProperty[0]?.property_address?.city) ? ", "+selectedProperty[0].property_address.city : ''}}
                                    {{(selectedProperty[0]?.property_address?.state) ? ", "+selectedProperty[0].property_address.state : ''}}
                                    {{(selectedProperty[0]?.property_address?.country) ? ", "+selectedProperty[0].property_address.country : ''}}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
        </mat-expansion-panel>
    </a>
</ng-template>
<!-- Project -->
<ng-template #projectRef *ngIf="utilityService.hasModuleAccess('PROJECT')">
    <a class="block w-full bg-white border-b border-gray-200">
        <mat-expansion-panel  [expanded]="true">
            <mat-expansion-panel-header>
            <mat-panel-title>
                <h5 class="my-4 flex items-center justify-between w-full text-lg font-semibold text-gray-700">
                    <div class="flex items-center">
                        <mat-icon [svgIcon]="'heroicons_outline:clipboard-document-check'" class="w-5 h-5 text-gray-800 min-h-5 min-w-5 mr-1"></mat-icon>
                        <span class="ml-3">
                            {{"text.project" | translate}}
                        </span>
                    </div>
                    <div *ngIf="selectedProject?.length">
                        <i class="ti ti-trash text-red-500 text-2xl p-1 rounded-full hover:bg-red-200" title="{{'tooltip.remove_project' | translate}}" (click)="$event.preventDefault();$event.stopPropagation();removeProject()"></i>
                    </div>
                </h5>
            </mat-panel-title>
            </mat-expansion-panel-header>
                <div class="rounded-md bg-blue-50 px-4 py-3" *ngIf="disableProjectField() && !selectedProject?.length">
                    <div class="flex">
                        <div class="flex-shrink-0">
                        <i class="ti ti-alert-circle text-blue-700 text-2xl"></i>
                        </div>
                        <div class="ml-3 flex-1 md:flex md:justify-between">
                            <p class="text-base text-blue-700">{{"alert.customer_or_organization_mandatory" | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="p-6 flex flex-col items-center justify-center" *ngIf="!selectedProject?.length">
                    <img src="/assets/images/svgs/no_organization_found.svg" class="h-32" alt="">
                    <a mat-stroked-button
                            [disabled]="disableProjectField()"
                            (click)="toggleProject()"
                            class="inline-flex items-center px-4 py-3 mt-4 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                            <em class="text-xl" class="ti ti-plus"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{'text.add_project' | translate}}</span>
                    </a>
                </div>
                <ng-container *ngIf="selectedProject?.length">
                    <div class="pt-2 flex flex-col rounded-md bg-white primary-font">
                        <div class="px-4 pb-3">
                            <div class="flex justify-between pt-3">
                                <p class="text-lg"> #{{selectedProject[0]?.project_prefix ?? ''}}{{!utilityService.isEmptyOrUndefined(selectedProject[0]?.project_number) ? selectedProject[0]?.project_number : ''}}</p>
                                <span>
                                    <badge class="capitalize" *ngIf="selectedProject[0]?.project_current_status"
                                        [options]="getBadgeOptions(selectedProject[0]?.project_current_status.status_type, selectedProject[0]?.project_current_status?.project_status_name, null, selectedProject[0]?.project_current_status?.project_status_color)">
                                    </badge>
                                </span>
                            </div>
                            <p [matTooltip]="selectedProject[0]?.project_name" class="text-lg font-bold max-w-4/5 truncate"> {{selectedProject[0]?.project_name}}</p>
                        </div>
                        <div class="flex flex-col p-1 px-4" *ngIf="selectedProject[0]?.project_due_date">
                            <span class="text-base text-gray-500 w-full font-medium max-w-3/4 truncate" *ngIf="selectedProject[0]?.project_due_date">
                                {{'text.due_by' | translate}} {{selectedProject[0]?.project_due_date | dateformat:', dddd'}}
                            </span>
                        </div>
                        <div class="flex p-1 px-4" *ngIf="selectedProject[0]?.project_category">
                            <div
                                class="flex flex-shrink-0 bg-gray-200 rounded-full items-center justify-center h-7 w-7">
                                <em class="ti ti-subtask text-2xl"></em>
                            </div>
                            <div class="flex min-w-0 ml-5 space-y-1">
                                <div class="flex items-center leading-6 truncate">
                                    <span class="text-gray-600 text-base truncate">
                                        {{selectedProject[0]?.project_category?.category_name ?? ''}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="flex mt-2 p-3 px-4 card-userassigned-bg"
                            *ngIf="selectedProject[0]?.project_priority">
                            <div class="ml-auto flex items-center justify-center cursor-default" *ngIf="selectedProject[0]?.project_priority">
                                <div class="flex label-height">
                                    <span class="flex text-base font-medium px-1 capitalize truncate items-center"> {{selectedProject[0]?.project_priority | lowercase}} {{'text.priority' | translate | lowercase}}</span>
                                    <span class="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" stroke-width="0"
                                            stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                            class="icon icon-tabler icon-tabler-circle icon-priority-{{selectedProject[0]?.project_priority}}">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                            <circle cx="12" cy="12" r="9"></circle>
                                        </svg>
                                    </span>
                                 </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
        </mat-expansion-panel>
    </a>
</ng-template>
<!-- Request -->
<ng-template #requestRef *ngIf="utilityService.hasModuleAccess('REQUEST')">
    <a class="block w-full bg-white border-b border-gray-200">
        <mat-expansion-panel  [expanded]="true">
            <mat-expansion-panel-header>
            <mat-panel-title>
                <h5 class="my-4 flex items-center justify-between w-full text-lg font-semibold text-gray-700">
                    <div class="flex items-center">
                        <i class="ti ti-tools text-2xl"></i>
                        <span class="ml-3">
                            {{"text.request" | translate}}
                        </span>
                    </div>
                    <div *ngIf="selectedRequest?.length">
                        <i class="ti ti-trash text-red-500 text-2xl p-1 rounded-full hover:bg-red-200" title="{{'tooltip.remove_request' | translate}}" (click)="$event.preventDefault();$event.stopPropagation();removeRequest()"></i>
                    </div>
                </h5>
            </mat-panel-title>
            </mat-expansion-panel-header>
                <div class="rounded-md bg-blue-50 px-4 py-3" *ngIf="disableRequestField() && !selectedRequest?.length">
                    <div class="flex">
                        <div class="flex-shrink-0">
                        <i class="ti ti-alert-circle text-blue-700 text-2xl"></i>
                        </div>
                        <div class="ml-3 flex-1 md:flex md:justify-between">
                        <p class="text-base text-blue-700">{{"alert.customer_mandatory" | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="p-6 flex flex-col items-center justify-center" *ngIf="!selectedRequest?.length">
                    <img src="/assets/images/svgs/attachment_placeholder.svg" class="h-32" alt="">
                    <a mat-stroked-button
                            [disabled]="disableRequestField()"
                            (click)="toggleRequest()"
                            class="inline-flex items-center px-4 py-3 mt-4 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                            <em class="text-xl" class="ti ti-plus"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{'text.add_request' | translate}}</span>
                    </a>
                </div>
                <ng-container *ngIf="selectedRequest?.length">
                    <div class="pt-2 flex flex-col rounded-md bg-white primary-font">
                        <div class="px-4 pb-3">
                            <div class="flex justify-between pt-3">
                                <p class="text-lg"> #{{!utilityService.isEmptyOrUndefined(selectedRequest[0]?.request_id) ? selectedRequest[0]?.request_id : ''}}</p>
                                <span>
                                    <badge class="capitalize" *ngIf="selectedRequest[0]?.request_status"
                                        [options]="getBadgeOptions(selectedRequest[0]?.request_status.status_type, selectedRequest[0]?.request_status?.status_name, null, selectedRequest[0]?.request_status?.status_color)">
                                    </badge>
                                </span>
                            </div>
                            <p [matTooltip]="selectedRequest[0]?.request_title" class="text-lg font-bold max-w-4/5 truncate"> {{selectedRequest[0]?.request_title}}</p>
                        </div>
                        <div class="px-4 pb-3">
                            <div class="flex mt-2" *ngIf="selectedRequest[0]?.service_address?.street">
                                <div
                                    class="flex flex-shrink-0 bg-gray-200 rounded-full items-center justify-center h-7 w-7">
                                    <em class="ti ti-map-pin text-xl"></em>
                                </div>
                                <div class="flex min-w-0 ml-3 space-y-1 text-base">
                                    <div class="flex items-center leading-6">
                                        {{selectedRequest[0]?.service_address?.street}}
                                        {{(selectedRequest[0]?.service_address?.city) ? ", "+selectedRequest[0].service_address.city : ''}}
                                        {{(selectedRequest[0]?.service_address?.state) ? ", "+selectedRequest[0].service_address.state : ''}}
                                        {{(selectedRequest[0]?.service_address?.country) ? ", "+selectedRequest[0].service_address.country : ''}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col p-1 px-4" *ngIf="selectedRequest[0]?.request_due_date">
                            <span class="text-base text-gray-500 w-full font-medium max-w-3/4 truncate" *ngIf="selectedRequest[0]?.request_due_date">
                                {{'text.due_by' | translate}} {{selectedRequest[0]?.request_due_date | dateformat:', dddd'}}
                            </span>
                        </div>
                        <div class="flex mt-2 p-3 px-4 card-userassigned-bg"
                            *ngIf="selectedRequest[0]?.request_priority">
                            <div class="ml-auto flex items-center justify-center cursor-default" *ngIf="selectedRequest[0]?.request_priority">
                                <div class="flex label-height">
                                    <span class="flex text-base font-medium px-1 capitalize truncate items-center"> {{selectedRequest[0]?.request_priority | lowercase}} {{'text.priority' | translate | lowercase}}</span>
                                    <span class="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" stroke-width="0"
                                            stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                            class="icon icon-tabler icon-tabler-circle icon-priority-{{selectedRequest[0]?.request_priority}}">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                            <circle cx="12" cy="12" r="9"></circle>
                                        </svg>
                                    </span>
                                 </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
        </mat-expansion-panel>
    </a>
</ng-template>

<!-- Contract -->
<ng-template #contractRef *ngIf="utilityService.hasModuleAccess('SERVICE_CONTRACTS')">
    <a class="block w-full bg-white border-b border-gray-200">
        <mat-expansion-panel  [expanded]="true">
            <mat-expansion-panel-header>
            <mat-panel-title>
                <h5 class="my-4 flex items-center justify-between w-full text-lg font-semibold text-gray-700">
                    <div class="flex items-center">
                        <i class="ti ti-file-text text-2xl"></i>
                        <span class="ml-3">
                            {{"contract" | translate}}
                        </span>
                    </div>
                    <div *ngIf="selectedContract.length">
                        <i class="ti ti-tool text-2xl p-1 rounded-full hover:bg-gray-200" title="{{'add.parts.text' | translate}}" (click)="$event.preventDefault();$event.stopPropagation();openContractLineItemPicker($event)"></i>
                        <i class="ti ti-trash text-red-500 text-2xl p-1 rounded-full hover:bg-red-200" title="{{'tooltip.remove.contract' | translate}}" (click)="$event.preventDefault();$event.stopPropagation();removeContract()"></i>
                    </div>
                </h5>
            </mat-panel-title>
            </mat-expansion-panel-header>
                <div class="rounded-md bg-blue-50 px-4 py-3" *ngIf="disableField() && !selectedContract.length">
                    <div class="flex">
                        <div class="flex-shrink-0">
                        <i class="ti ti-alert-circle text-blue-700 text-2xl"></i>
                        </div>
                        <div class="ml-3 flex-1 md:flex md:justify-between">
                        <p class="text-base text-blue-700">{{"alert.customer_or_organization_mandatory" | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="p-6 flex flex-col items-center justify-center" *ngIf="!selectedContract?.length">
                    <img src="/assets/images/svgs/contract_placeholder.svg" class="h-32" alt="">
                    <a mat-stroked-button
                            [disabled]="disableField()"
                            (click)="toggleContract()"
                            class="inline-flex items-center px-4 py-3 mt-4 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                            <em class="text-xl" class="ti ti-plus"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{'job.details.actions.add.contracts' | translate}}</span>
                    </a>
                </div>
                <ng-container *ngIf="selectedContract?.length">
                    <div class="px-4 pb-3">
                        <div class="flex justify-between pt-3">
                            <p class="text-lg"><span *ngIf="selectedContract[0]?.prefix">{{selectedContract[0]?.prefix}}</span>{{selectedContract[0]?.contract_number}}</p>
                            <span>
                                <badge class="capitalize"
                                    [options]="getBadgeOptions(selectedContract[0]?.approval_status, getStatusText(selectedContract[0]?.approval_status))">
                                </badge>
                            </span>
                        </div>
                        <p class="text-xl font-semibold">{{selectedContract[0]['contract_name']}}</p>
                        <div class="flex mt-2" *ngIf="selectedContract[0]?.customer?.customer_first_name">
                            <div
                                class="flex flex-shrink-0 bg-gray-200 rounded-full items-center justify-center h-7 w-7">
                                <em class="ti ti-user text-xl"></em>
                            </div>
                            <div class="flex min-w-0 ml-3 space-y-1 text-base">
                                <div class="flex items-center leading-6 truncate">
                                    {{selectedContract[0]?.customer?.customer_first_name}} {{selectedContract[0]?.customer?.customer_last_name}}
                                </div>
                            </div>
                        </div>
                        <div class="flex mt-2" *ngIf="selectedContract[0]?.organization?.organization_name">
                            <div
                                class="flex flex-shrink-0 bg-gray-200 rounded-full items-center justify-center h-7 w-7">
                                <em class="ti ti-building text-xl"></em>
                            </div>
                            <div class="flex min-w-0 ml-3 space-y-1 text-base">
                                <div class="flex items-center leading-6 truncate">
                                    {{selectedContract[0]?.organization?.organization_name}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-between py-3 border-t px-4 text-base">
                        <p>{{"text.expires_on" | translate}}: {{selectedContract[0].end_date | dateformat}}</p>
                        <p class="text-primary" *ngIf="selectedContract[0]?.term_months">{{selectedContract[0].term_months}} {{"text.months" | translate}}</p>
                    </div>
                </ng-container>
        </mat-expansion-panel>
    </a>
</ng-template>

<!-- Asset -->
<ng-template #assetRef *ngIf="utilityService.hasModuleAccess('ASSETS')">
    <a class="block w-full bg-white border-b border-gray-200">
        <mat-expansion-panel  [expanded]="true">
            <mat-expansion-panel-header>
            <mat-panel-title>
                <h5 class="my-4 flex items-center justify-between w-full text-lg font-semibold text-gray-700">
                    <div class="flex items-center">
                        <i class="ti ti-box text-2xl"></i>
                        <span class="ml-3">
                            {{"asset.text" | translate}}
                        </span>
                        <span class="ml-1" *ngIf="selectedAssets?.length">
                            ({{selectedAssets.length}})
                        </span>
                    </div>
                    <div *ngIf="selectedAssets.length">
                        <i class="ti ti-plus text-2xl p-1 rounded-full hover:bg-gray-200" title="{{'tooltip.add.assets' | translate}}" (click)="$event.preventDefault();$event.stopPropagation();toggleAsset()"></i>
                    </div>
                </h5>
            </mat-panel-title>
            </mat-expansion-panel-header>
                <div class="rounded-md bg-blue-50 px-4 py-3" *ngIf="disableField() && !selectedAssets.length">
                    <div class="flex">
                        <div class="flex-shrink-0">
                        <i class="ti ti-alert-circle text-blue-700 text-2xl"></i>
                        </div>
                        <div class="ml-3 flex-1 md:flex md:justify-between">
                        <p class="text-base text-blue-700">{{"alert.customer_or_organization_mandatory" | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="p-6 flex flex-col items-center justify-center" *ngIf="!selectedAssets.length">
                    <img src="/assets/images/svgs/asset_placeholder.svg" class="h-32" alt="">
                    <a mat-stroked-button
                            [disabled]="disableField()"
                            (click)="toggleAsset()"
                            class="inline-flex items-center px-4 py-3 mt-4 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                            <em class="text-xl" class="ti ti-plus"></em><span
                                class="ml-2 primary-font text-base leading-loose pt-0.5">{{'job.details.actions.add.asset' | translate}}</span>
                    </a>
                </div>
                <ng-container *ngIf="selectedAssets.length">
                    <div *ngFor="let asset of selectedAssets; let i = index" class="border-b pb-3 border-gray-200">
                        <div class="flex px-4 pt-3 justify-between">
                            <div class="flex items-center w-7/12">
                                <p class="text-base font-semibold pt-1">{{asset?.asset_name}}</p>
                            </div>
                            <div class="w-5/12 flex items-center justify-end">
                                <badge class="capitalize"
                                    *ngIf="asset?.asset_status"
                                    [options]="getBadgeOptions(asset?.asset_status, getAssetStatusText(asset?.asset_status))">
                                </badge>
                                <div class="inline-flex items-center">
                                    <button [matMenuTriggerFor]="assetMenu" mat-icon-button class="inline-flex items-center ml-1 rounded-full border border-transparent text-black" [ngClass]=""><em class="ti ti-dots-vertical text-xl mt-0.5 mr-0.5"></em></button>
                                    <mat-menu #assetMenu="matMenu">
                                      <!-- <div mat-menu-item class="primary-font text-base h-10" (click)="performPartsAction('viewDetails',element)">
                                        <div class="flex items-center space-x-2">
                                            <div class="menu-item-drag">
                                                <em class="ti ti-eye text-xl"></em>
                                            </div>
                                            <div class="primary-font text-base text-gray-700">
                                                <span>{{'text.view_details' | translate}}</span>
                                            </div>
                                        </div>
                                      </div> -->
                                      <div mat-menu-item class="primary-font text-base h-10" (click)="openAssetLineItemPicker($event, i)">
                                        <div class="flex items-center space-x-2">
                                            <div class="menu-item-drag">
                                                <em class="ti ti-tool text-xl"></em>
                                            </div>
                                            <div class="primary-font text-base text-gray-700">
                                                <span>{{'add.parts.text' | translate}}</span>
                                            </div>
                                        </div>
                                      </div>
                                      <div mat-menu-item class="primary-font text-base h-10" (click)="removeAsset(i)">
                                        <div class="flex items-center text-red-600 space-x-2">
                                            <div class="menu-item-drag">
                                                <em class="ti ti-trash text-xl"></em>
                                            </div>
                                            <div class="primary-font text-base text-red-600">
                                                <span>{{'text.remove' | translate}}</span>
                                            </div>
                                        </div>
                                      </div>
                                    </mat-menu>
                                  </div>
                            </div>
                        </div>
                        <!-- <div class="px-4 pb-3 flex">
                                <div class="relative flex flex-0 items-center justify-center w-12 h-12 self-center">
                                    <ng-container *ngIf="asset?.asset_image">
                                        <img
                                            class="w-full h-full rounded object-cover"
                                            [src]="asset?.asset_image"
                                            alt="Contact avatar"/>
                                    </ng-container>
                                    <ng-container *ngIf="!asset?.asset_image">
                                        <div class="flex items-center justify-center w-full h-full rounded text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                            {{asset?.asset_name.charAt(0)}}
                                        </div>
                                    </ng-container>
                                </div>
                                <div class="min-w-0 ml-4">
                                    <p *ngIf="asset?.asset_serial_number" class="mt-0.5 text-base truncate">{{"text.serial_no" | translate}}: {{asset?.asset_serial_number}}</p>                        
                                    <p *ngIf="asset?.warranty_expiry_date" class="mt-0.5 text-base truncate">{{"assets.table.warranty_expiry_date" | translate}}: {{assetwarranty_expiry_datewarranty_expiry_date | dateformat}}</p>                  
                                </div>
                        </div> -->
                    </div>
                </ng-container>
        </mat-expansion-panel>
    </a>
</ng-template>

<!-- Attachments -->
<ng-template #attachmentsRef>
    <a class="block w-full bg-white border-b border-gray-200">
        <mat-expansion-panel  [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h5 class="my-4 flex items-center justify-between w-full text-lg font-semibold text-gray-700">
                    <div class="flex items-center">
                        <i class="ti ti-paperclip text-2xl"></i>
                        <span class="ml-3">
                            {{'text.attachments' | translate}}
                        </span>
                        <span class="ml-1" *ngIf="attachments?.length">
                            ({{attachments.length}})
                        </span>
                    </div>
                    <div>
                        <em class="ti ti-plus text-2xl flex items-center justify-center hover:bg-gray-200 p-2 rounded-full" (click)="addAttachments($event)" *ngIf="attachments?.length > 0" matTooltip="{{'add.text' | translate}}"></em>
                    </div>
                </h5>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="p-6 flex flex-col items-center justify-center" *ngIf="!attachments.length">
                <img src="/assets/images/svgs/attachment_placeholder.svg" class="h-32" alt="">
                <a mat-stroked-button
                        (click)="addAttachments($event)"
                        class="inline-flex items-center px-4 py-3 mt-4 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                        <em class="text-xl" class="ti ti-plus"></em><span
                            class="ml-2 primary-font text-base leading-loose pt-0.5">{{'attachment.new.add.header' | translate}}</span>
                        </a>
                        <div class="py-1 primary-font text-base leading-loose mt-2 text-gray-700 text-center">{{"attachment.placeholder.description.job" | translate}}</div>
            </div>
            <div class="p-4 flex flex-col" *ngIf="attachments.length > 0">
                <div class="w-full flex flex-col">
                    <ng-container *ngFor="let data of attachments;let i=index">
                        <file-placeholder class="w-full pr-1 my-1.5 bg-white" [options]="getPlaceholderOptions(data)"
                            (fileEventEmitter)="fileEventEmitHandler($event, i)">
                        </file-placeholder>
                    </ng-container>
                </div>
            </div>
        </mat-expansion-panel>
    </a>
</ng-template>

<zuper-drawer [name]="'recurringDrawer'" class="jobRecurringDrawer" [mode]="options.mode" [position]="options.position"
[transparentOverlay]="false" [hideOnClickOutside]="false" (openedChanged)="drawerOpenedChanged($event)" [fixed]="true">
    <div class="h-full w-full">
        <div class="p-2 border-b border-gray-300 flex justify-between">
            <div class="primary-font font-bold text-2xl text-gray-900 flex items-center pl-2">
                {{"recurrence.choose.header" | translate}}
            </div>
            <div>
                <button type="button" mat-icon-button (click)="closeDrawer()">
                    <em class="ti ti-x text-gray-900 text-xl"></em>
                </button>
            </div>
        </div>
        <div class=" w-full flex flex-col space-y-4 recurring-drawer-container zuper-scrollbar">
            <div class="px-3 pt-3 w-full bg-white">
                <app-recurrence-schedule [formGroup]="rruleForm" (eventChange)="getRrule($event)" *ngIf="openPicker"></app-recurrence-schedule>
            </div>
                <app-rrule-date [dateGroup]="dateGroup" [options]="rruleDateOptions" [jobs]="jobs" *ngIf="openPicker" class="m-3"></app-rrule-date>
        </div>
        <div class="text-right border-gray-300 border-t zuper-dialog-footer pb-3">
            <button type="button" (click)="closeDrawer()" class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none mr-2">{{"cancel.text" | translate}}</button>
            <button type="button" (click)="saveRrule()" class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary focus:outline-none">{{"text.save" | translate}}</button>
        </div>
    </div>
</zuper-drawer>

<zuper-drawer
    class="assign-employee"
    [fixed]="true"
    [mode]= "'over'"
    [name]="'assignEmployeeDrawer'"
    [position]="'right'"
    [transparentOverlay]="false"
    [hideOnClickOutside]="false"
    (openedChanged)="onJobAssigneeChanged($event)"
    >
    <div class="w-full h-full" *ngIf="openEmployee">
        <zuper-assign-employee [options]="assignEmployeeOptions" (eventEmitter)="onAssignmentEventEmitted($event)"></zuper-assign-employee>
    </div>
</zuper-drawer>

<zuper-drawer
    class="service-task"
    [fixed]="true"
    [mode]= "'over'"
    [name]="'serviceTaskDrawer'"
    [position]="'right'"
    [transparentOverlay]="false"
    [hideOnClickOutside]="false"
    (openedChanged)="onTaskChanged($event)"
    >
    <div class="w-full h-full" *ngIf="openTask">
        <app-service-task-form [options]="serviceTaskOption" (drawerClose)="onServiceTaskClose($event, 'serviceTaskDrawer')"></app-service-task-form>
    </div>
</zuper-drawer>

<data-picker 
    (eventEmitter)="dataPickerEventHandler($event)"
    [openPicker]="openDataPicker" 
    [module]="currentPickerModule" 
    [options]="currentPickerOptions"
    [filter]="getPickerFilter()"
></data-picker>

<ng-container *ngIf="showManageAddress">
    <app-address-component  [addressOptions]="addressOptions" (selectedAddress)="onAddressSelect($event)"></app-address-component>
</ng-container>

<ng-template #assigEmployeeToTask let-hide>
    <app-assign-tooltip  [assignListData]="getAssignEmployee()" [showNotifyEmployee]="false" [assignedEmployee]="this.currentServiceTask?.['assigned_to']" (assignedEmployeeEmitter)="assignedEmployeeEmitter($event)"></app-assign-tooltip>
</ng-template>

<!-- Job  Service Territory-->
<ng-template #territoryNewConflict let-hide>
    <job-service-territory-tooltip *ngIf="service_territory?.matched_territory?.is_conflict === true && service_territory?.matched_territory?.conflicts?.length > 0" [options]="serviceTerritoryOptions" (closetoolTip)="closeToolTip($event)"></job-service-territory-tooltip>
</ng-template>

<zuper-drawer
    class="bundle-details"
    [fixed]="true"
    [mode]= "'over'"
    [name]="'viewBundleDetailDrawer'"
    [position]="'right'"
    [transparentOverlay]="false"
    [hideOnClickOutside]="false"
    (openedChanged)="onBundleDrawerOpenChanged($event)"
    >
    <div class="w-full h-full bg-white" *ngIf="openBundleDetails">
        <app-bundle-details [productDetails]="bundleDetails"></app-bundle-details>
    </div>
</zuper-drawer>